/** Fluxul better-auth passwordless (email OTP), 2FA, passkey, sesiune. */
import { api } from './client';

export interface OtpSignInResult {
  token?: string;
  user?: { id: string; email: string };
  /** better-auth cere 2FA: răspunsul semnalează redirect/twoFactorRedirect. */
  twoFactorRedirect?: boolean;
}

/** Trimite (sau retrimite) codul OTP de 6 cifre pe email. `type: 'sign-in'` creează contul dacă e nou. */
export async function sendOtp(email: string): Promise<{ success: boolean }> {
  return api.post('/api/auth/email-otp/send-verification-otp', { email, type: 'sign-in' });
}

/** Verifică OTP-ul și creează sesiunea. Poate întoarce `twoFactorRedirect` dacă e activat 2FA. */
export async function verifyOtp(email: string, otp: string): Promise<OtpSignInResult> {
  return api.post('/api/auth/sign-in/email-otp', { email, otp });
}

/** Verifică al doilea factor (TOTP). */
export async function verifyTotp(code: string): Promise<OtpSignInResult> {
  return api.post('/api/auth/two-factor/verify-totp', { code });
}

/** Deconectare (șterge sesiunea curentă). */
export async function signOut(): Promise<unknown> {
  return api.post('/api/auth/sign-out', {});
}

/** URL-ul de start pentru Google OAuth (dacă e configurat în API). */
export function googleSignInUrl(): string {
  const base = (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/$/, '') ?? '';
  const callback = `${window.location.origin}/`;
  return `${base}/api/auth/sign-in/social?provider=google&callbackURL=${encodeURIComponent(callback)}`;
}
